import { SVGProps, Ref, forwardRef } from 'react';

export const OvalSplitFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.104 6.667c.118-1.593.455-2.521.884-3.063.458-.579 1.26-1.004 3.01-1.004 1.751 0 2.554.425 3.011 1.004.43.542.766 1.47.884 3.063h1.604C13.227 2.612 11.613 1 8 1S2.77 2.612 2.5 6.667z"
                fill="currentColor"
            />
            <path
                d="M4.104 9.333H2.5C2.77 13.388 4.384 15 7.999 15s5.228-1.612 5.498-5.667h-1.604c-.118 1.593-.455 2.521-.884 3.063-.457.579-1.26 1.004-3.01 1.004-1.751 0-2.553-.425-3.011-1.004-.43-.542-.766-1.47-.884-3.063"
                fill="currentColor"
            />
        </g>
    </svg>
));
OvalSplitFilledSize16Glyph.displayName = 'OvalSplitFilledSize16Glyph';
